import { render, staticRenderFns } from "./user-view.vue?vue&type=template&id=5410c2f4&scoped=true"
import script from "./user-view.vue?vue&type=script&lang=js"
export * from "./user-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410c2f4",
  null
  
)

export default component.exports